import { render, staticRenderFns } from "./MedicinesList.vue?vue&type=template&id=448a8487"
import script from "./MedicinesList.js?vue&type=script&lang=js&external"
export * from "./MedicinesList.js?vue&type=script&lang=js&external"
import style0 from "./MedicinesList.vue?vue&type=style&index=0&id=448a8487&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports